/**
 * Generates a temporary password that satisfies the pool policy (>= 8 chars,
 * upper, lower, digit, symbol) and is easy to read aloud / type on a phone:
 * no ambiguous glyphs (0/O, 1/l/I), a small set of well-known symbols, 12 chars.
 */
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ'
const LOWER = 'abcdefghijkmnpqrstuvwxyz'
const DIGIT = '23456789'
const SYMBOL = '!@#$%*'
const ALL = UPPER + LOWER + DIGIT + SYMBOL

const randomInts = (n) => {
  const buf = new Uint32Array(n)
  crypto.getRandomValues(buf)
  return Array.from(buf)
}

const pick = (alphabet, n) => randomInts(n).map((r) => alphabet[r % alphabet.length])

export const generateTemporaryPassword = (length = 12) => {
  const chars = [
    ...pick(UPPER, 1),
    ...pick(LOWER, 1),
    ...pick(DIGIT, 1),
    ...pick(SYMBOL, 1),
    ...pick(ALL, Math.max(4, length) - 4),
  ]
  // Fisher–Yates with crypto-random indices
  const rnd = randomInts(chars.length)
  for (let i = chars.length - 1; i > 0; i -= 1) {
    const j = rnd[i] % (i + 1)
    ;[chars[i], chars[j]] = [chars[j], chars[i]]
  }
  return chars.join('')
}

export const PASSWORD_POLICY_TEXT = 'Mínimo de 8 caracteres, com letra maiúscula, minúscula, número e símbolo.'

export const meetsPasswordPolicy = (pwd) =>
  typeof pwd === 'string' && pwd.length >= 8 && /[a-z]/.test(pwd) && /[A-Z]/.test(pwd) && /\d/.test(pwd) && /[^A-Za-z0-9]/.test(pwd)
